// extracted by mini-css-extract-plugin
export default {"dividerWrapper":"divider_dividerWrapper__ajf-Y","divider":"divider_divider__xIU4D","shapeFill":"divider_shapeFill__DtLoF"};